import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListTimeKeepingManagerSlice = createSlice({
  name: "getListTimeKeepingManager",
  initialState,
  reducers: {
    getListTimeKeepingManagerStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListTimeKeepingManagerSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListTimeKeepingManagerFailed: (
      state,
      action: PayloadAction<{ type: string }>
    ) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
      state.totalRecords = 0;
    },

    resetListTimeKeepingManager: (state) => initialState,
  },
});

export const {
  getListTimeKeepingManagerStart,
  getListTimeKeepingManagerSuccess,
  getListTimeKeepingManagerFailed,
  resetListTimeKeepingManager,
} = getListTimeKeepingManagerSlice.actions;

export default getListTimeKeepingManagerSlice.reducer;
